/**
 * AG Grid v35+ Global Setup
 * 
 * AG Grid v35 introduced a new theming and module system. This file must be imported
 * ONCE at the application entry point (index.tsx) to ensure all AG Grid instances
 * have the required modules registered before any grid renders.
 * 
 * This replaces the need for individual components to register modules themselves.
 */
import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

// Import AG Grid CSS globally so individual components don't need to
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

// Register all modules globally - this must happen before any AgGridReact renders
ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

// Use legacy theme mode globally so all grids that use className="ag-theme-alpine"
// continue to work with the CSS-based theming approach from v32.
// This avoids needing to add theme="legacy" to every single <AgGridReact> instance.
provideGlobalGridOptions({ theme: 'legacy' });
